import{a as b}from"./chunk.DWL5QFAQ.js";import{b as d}from"./chunk.CUOPQL3Y.js";import{a as u}from"./chunk.2AIXLGYE.js";import{a as m}from"./chunk.VDLOD2KK.js";import{a as s}from"./chunk.XPINZPW5.js";import{a as h}from"./chunk.65JZXZ5X.js";import{d as c}from"./chunk.DQ7YBHX4.js";import{a as f}from"./chunk.5456T7GL.js";import{a as p}from"./chunk.LWUQDFQZ.js";import{c as t}from"./chunk.NWIV65VP.js";import{html as y}from"lit/static-html.js";import{property as o,query as $,state as g}from"lit/decorators.js";import{classMap as x}from"lit/directives/class-map.js";import{ifDefined as i}from"lit/directives/if-defined.js";import{live as k}from"lit/directives/live.js";import{css as w}from"lit";var v=w`
  ${u}
  ${b}

  :host {
    display: block;
  }

  .search-box {
    flex: 1 1 auto;
    display: inline-flex;
    align-items: stretch;
    justify-content: start;
    position: relative;
    width: 100%;
    height: var(--he-form-control-height);
    font-family: var(--he-form-control-font-family);
    font-size: var(--he-form-control-font-size);
    line-height: var(--he-line-height-normal);
    vertical-align: middle;
    background-color: var(--he-color-neutral-0);
    border-radius: var(--he-form-control-border-radius);
    border: solid var(--he-form-control-border-width) var(--he-form-control-border-color);
    overflow: hidden;
    cursor: text;
  }

  .search-box--focused:not(.search-box--disabled) {
    border-color: var(--he-form-control-focus-ring-color);
    outline: solid var(--he-form-control-border-width) var(--he-form-control-focus-ring-color);
    outline-offset: -2px;
  }

  .search-box--disabled {
    opacity: var(--he-form-control-disabled-opacity);
    cursor: not-allowed;
  }

  .search-box--disabled .search-box__control::placeholder {
    color: var(--he-form-control-placeholder-color);
  }

  .search-box__control {
    flex: 1 1 auto;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    min-width: 0;
    color: var(--he-form-control-color);
    border: none;
    background: none;
    box-shadow: none;
    margin: 0;
    cursor: inherit;
    -webkit-appearance: none;
    height: calc(var(--he-form-control-height) - var(--he-form-control-border-width) * 2);
    padding: 0 var(--he-spacing-x-small);
  }

  .search-box__control::-webkit-search-decoration,
  .search-box__control::-webkit-search-cancel-button,
  .search-box__control::-webkit-search-results-button,
  .search-box__control::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  .search-box__control:-webkit-autofill,
  .search-box__control:-webkit-autofill:hover,
  .search-box__control:-webkit-autofill:focus,
  .search-box__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--he-form-control-height) var(--he-color-neutral-0) inset !important;
    -webkit-text-fill-color: var(--he-color-primary-500);
    caret-color: var(--he-input-color);
  }

  .search-box__control::placeholder {
    color: var(--he-form-control-placeholder-color);
    user-select: none;
  }

  .search-box__control:focus {
    outline: none;
  }

  .search-box__search-icon {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    color: var(--he-color-primary-600);
    padding-inline-start: var(--he-spacing-x-small);
    padding-inline-end: var(--he-spacing-2x-small);
    cursor: default;
  }

  /*
   * Clearable
   */
  .search-box__clear {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    color: var(--he-form-control-color);
    border: none;
    background: none;
    padding: 0;
    padding-inline-end: var(--he-spacing-x-small);
    cursor: pointer;
  }

  .search-box__clear:hover {
    color: var(--he-form-control-color);
  }

  .search-box__clear:focus {
    outline: none;
  }

  .search-box--empty .search-box__clear {
    visibility: hidden;
  }

  .search-box__clear-icon {
    font-size: var(--he-font-size-medium);
  }

  .form-control--has-interaction.form-control--has-error .search-box {
    border-color: var(--he-form-control-error-color) !important;
    outline-color: var(--he-form-control-error-color) !important;
  }
`;var e=class extends h{constructor(){super();this.formSubmitController=new p(this);this.hasSlotController=new m(this,"help-text","label");this.scope=c(this);this.hasFocus=!1;this.isPasswordVisible=!1;this.type="text";this.value="";this.defaultValue="";this.label="";this.helpText="";this.disabled=!1;this.readonly=!1;this.required=!1;this.invalid=!1;this.scope.registerComponent(d),this.placeholder||(this.placeholder=this.localize.term("search"))}firstUpdated(){this.invalid=!this.input.checkValidity()}focus(r){this.input.focus(r)}blur(){this.input.blur()}select(){this.input.select()}setSelectionRange(r,l,a="none"){this.input.setSelectionRange(r,l,a)}setRangeText(r,l,a,n="preserve"){this.input.setRangeText(r,l,a,n),this.value!==this.input.value&&(this.value=this.input.value,this.emit("he-input"),this.emit("he-change"))}checkValidity(){return this.input.checkValidity()}get validationMessage(){return this.input.validationMessage}reportValidity(){return this.input.reportValidity()}setCustomValidity(r){this.input.setCustomValidity(r),this.invalid=!this.input.checkValidity()}handleBlur(){this.hasFocus=!1,this.emit("he-blur")}handleChange(){this.value=this.input.value,this.emit("he-change")}handleClearClick(r){this.value="",this.emit("he-clear"),this.emit("he-input"),this.emit("he-change"),this.input.focus(),r.stopPropagation()}handleDisabledChange(){this.input.disabled=this.disabled,this.invalid=!this.input.checkValidity()}handleFocus(){this.hasFocus=!0,this.emit("he-focus")}handleInput(){this.value=this.input.value,this.emit("he-input")}handleInvalid(){this.invalid=!0}handleKeyDown(r){let l=r.metaKey||r.ctrlKey||r.shiftKey||r.altKey;r.key==="Enter"&&!l&&setTimeout(()=>{r.defaultPrevented||this.formSubmitController.submit()})}handleValueChange(){this.invalid=!this.input.checkValidity()}render(){let r=this.hasSlotController.test("label"),l=this.hasSlotController.test("help-text"),a=this.label?!0:!!r,n=this.helpText?!0:!!l,_=!this.disabled&&!this.readonly&&(typeof this.value=="number"||this.value.length>0);return y`
      <div
        part="form-control"
        class=${x({"form-control":!0,"form-control--has-label":a,"form-control--has-help-text":n})}
      >
        <label
          part="form-control-label"
          class="form-control__label"
          for="input"
          aria-hidden=${a?"false":"true"}
        >
          <slot name="label">${this.label}</slot>
        </label>
        <div part="form-control-input" class="form-control-input">
          <div
            part="base"
            class=${x({"search-box":!0,"search-box--disabled":this.disabled,"search-box--focused":this.hasFocus,"search-box--empty":!this.value,"search-box--invalid":this.invalid})}
          >
            <span part="search-icon" class="search-box__search-icon">
              <${this.scope.tag("icon")} name="search">
              </${this.scope.tag("icon")}>
            </span>
            <input
              part="input"
              id="input"
              class="search-box__control"
              type="search"
              name=${i(this.name)}
              ?disabled=${this.disabled}
              ?readonly=${this.readonly}
              ?required=${this.required}
              placeholder=${i(this.placeholder)}
              minlength=${i(this.minlength)}
              maxlength=${i(this.maxlength)}
              .value=${k(this.value)}
              autocapitalize=${i(this.autocapitalize)}
              autocomplete=${i(this.autocomplete)}
              autocorrect=${i(this.autocorrect)}
              ?autofocus=${this.autofocus}
              spellcheck=${i(this.spellcheck)}
              pattern=${i(this.pattern)}
              enterkeyhint=${i(this.enterkeyhint)}
              inputmode=${i(this.inputmode)}
              aria-describedby="help-text"
              aria-invalid=${this.invalid?"true":"false"}
              @change=${this.handleChange}
              @input=${this.handleInput}
              @invalid=${this.handleInvalid}
              @keydown=${this.handleKeyDown}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
            />
            ${_?y`
                  <button
                    part="clear-button"
                    class="search-box__clear"
                    type="button"
                    aria-label=${this.localize.term("clear_entry")}
                    @click=${this.handleClearClick}
                    tabindex="-1"
                  >
                    <${this.scope.tag("icon")} name="clear" library="system" class="search-box__clear-icon">
                    </${this.scope.tag("icon")}>
                  </button>
                `:""}
          </div>
        </div>
        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${n?"false":"true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
        <div
          part="form-control-error-text"
          id="error-text"
          class="form-control__error-text"
          aria-live="assertive"
        ></div>
      </div>
    `}};e.styles=v,e.baseName="search-box",e.reactEvents={onHeBlur:new CustomEvent("he-blur"),onHeChange:new CustomEvent("he-change"),onHeClear:new CustomEvent("he-clear"),onHeFocus:new CustomEvent("he-focus"),onHeInput:new CustomEvent("he-input")},t([$(".search-box__control")],e.prototype,"input",2),t([g()],e.prototype,"hasFocus",2),t([g()],e.prototype,"isPasswordVisible",2),t([o({reflect:!0})],e.prototype,"type",2),t([o()],e.prototype,"name",2),t([o()],e.prototype,"value",2),t([f()],e.prototype,"defaultValue",2),t([o()],e.prototype,"label",2),t([o({attribute:"help-text"})],e.prototype,"helpText",2),t([o()],e.prototype,"placeholder",2),t([o({type:Boolean,reflect:!0})],e.prototype,"disabled",2),t([o({type:Boolean,reflect:!0})],e.prototype,"readonly",2),t([o({type:Number})],e.prototype,"minlength",2),t([o({type:Number})],e.prototype,"maxlength",2),t([o()],e.prototype,"pattern",2),t([o({type:Boolean,reflect:!0})],e.prototype,"required",2),t([o({type:Boolean,reflect:!0})],e.prototype,"invalid",2),t([o()],e.prototype,"autocapitalize",2),t([o()],e.prototype,"autocorrect",2),t([o()],e.prototype,"autocomplete",2),t([o({type:Boolean,reflect:!0})],e.prototype,"autofocus",2),t([o()],e.prototype,"enterkeyhint",2),t([o({type:Boolean,reflect:!0})],e.prototype,"spellcheck",2),t([o()],e.prototype,"inputmode",2),t([s("disabled",{waitUntilFirstUpdate:!0})],e.prototype,"handleDisabledChange",1),t([s("value",{waitUntilFirstUpdate:!0})],e.prototype,"handleValueChange",1);var O=e;export{e as a,O as b};
